import styled from "styled-components";

export const Wrapper = styled.div`
    max-width: 350px;
    border-radius: 12px;
    box-shadow: 0px 4px 16px 0px #0000000A;
    background-color: white;
    padding: 10px;
`

export const Header = styled.div`
    margin-bottom: 16px;
    display: flex;
    justify-content: space-between;
`

export const FormatedDate = styled.span`
    font-size: 16px;
    font-weight: 600;
`

export const NavWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 10px;
`

export const Nav = styled.button`
    padding: 6px 10px;
    border-radius: 12px;
    background-color: rgba(197, 193, 193, 0.77);
    border: 0;

    &:hover {
        background-color: #f6f6f6;
        border: 0;
        cursor: pointer;
    }
`

